import { axiosClient, getToken } from 'Config/axiosConfig';

export const getUsuarios = async (limit: number = 200, offset: number = 0) => {
  await getToken();
  return await axiosClient.get(`/usuarios?limit=${limit}&offset=${offset}`);
};

export const getEmpresas = async () => {
  await getToken();
  return await axiosClient.get(`/empresas`);
};

export const getEmpresasByUsuario = async (usuarioId: number) => {
  await getToken();
  return await axiosClient.get(`/usuarios/${usuarioId}/empresas`);
};

export const addUsuarioEmpresa = async (usuario_id: number, empresa_id: number) => {
  await getToken();
  return await axiosClient.post(`/usuarios_empresas`, { usuario_id, empresa_id });
};

export const removeUsuarioEmpresa = async (usuario_id: number, empresa_id: number) => {
  await getToken();
  return await axiosClient.delete(`/usuarios/${usuario_id}/empresas/${empresa_id}`);
};

